var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVsHotmatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 12,
    rx: 6,
    fill: "#DC2626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.5) scale(0.875 0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.244 0H14.844L8.744 14H6.184L.064 0H2.884L7.544 10.8 12.244 0zm6.239 14.14c-1.78 0-3.56-.52-4.52-1.2l.96-1.9c.9.62 2.34 1.06 3.68 1.06 1.58 0 2.24-.44 2.24-1.18 0-2.04-6.6-1.26-6.6-4.6 0-2.02 1.82-3.2 4.7-3.2 1.42 0 3.04.34 4 1.02l-.96 1.82c-.98-.6-2.02-.8-3.02-.8-1.52 0-2.22.5-2.22 1.2 0 1.86 6.6 1.08 6.6 4.18 0 2-1.84 3.14-4.84 3.14z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsHotmatch);
export default __webpack_public_path__ + "static/media/vs_hotmatch.49394c9337398800751ebfb9debd26bf.svg";
export { ForwardRef as ReactComponent };